module.exports = __webpack_public_path__ + "static/media/ludovic_circle.bebf3553.png";